module.exports = __webpack_public_path__ + "img/traffic_scooter.90757380.png";